import * as d3 from "d3";
import $ from 'jquery';
import { addCommas, addPlus } from './helpers';
import * as axios from 'axios';
const moment = require('moment');

d3.selectAll(".genderpopCheckbox").on("change", updateCharts);
function updateCharts() {
    let genderpop = $("input[type='radio'][name='genderradio']:checked").val();

    d3.selectAll('.chartwrapper').remove()

    const caseData = axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vRb8zyDNZXyPrSgwxUxENm2jKPV-ewDJF_CbEGWvCNuYzXZT_6YwCv209lTeyI6tUIL6jRl6ZWD5Dcv/pub?gid=1704181121&single=true&output=csv")
        .then(content => {
            const justData = content.data
            const facilities = d3.csvParse(justData)

            var parseDate = d3.timeParse("%Y-%m-%d");
            facilities.forEach(function (d) {
                d.newDate = parseDate(d.date);
            })
            facilities.sort((a, b) => a.newDate - b.newDate)

            const datalength = facilities.length

            const currentDate = facilities[datalength - 1].newDate
            var formatDate = d3.timeFormat("%Y-%m-%d");

            const allCurrentDate = facilities.filter(d => d.date == formatDate(currentDate))

            const femalePop = facilities.filter(function (d) { return d.sex === "Females" })
            const malePop = facilities.filter(function (d) { return d.sex === "Males" })

            var formatTime = d3.timeFormat("%m/%d/%Y");
            var formatTimeforMoment = d3.timeFormat("%Y-%m-%d");

            let momentCurrentDay = moment(formatTimeforMoment(currentDate))

            $(".total-pop-date").text(formatTime(currentDate))
            let facilitiesData

            if (genderpop == "females") { facilitiesData = femalePop }
            else if (genderpop == "males") { facilitiesData = malePop }
            else { facilitiesData = facilities }

            let aWeekAgo = momentCurrentDay.clone().subtract(1, 'week')

            let aMonthAgo = momentCurrentDay.clone().subtract(1, 'month')

            let aYearAgo = momentCurrentDay.clone().subtract(1, 'year')

            ////// find the date closest to a year ago

            const datesToBeChecked = facilities.map(a => a.date);
            const dateToCheckFor = aYearAgo

            let nearestDate;

            datesToBeChecked.forEach(date => {
                let diff = moment(date).diff(moment(dateToCheckFor), 'days');
                if (diff > 0) {
                    if (nearestDate) {
                        if (moment(date).diff(moment(nearestDate), 'days') < 0) {
                            nearestDate = date;
                        }
                    } else {
                        nearestDate = date;
                    }
                }
            });

            let nearestDateWeek;

            datesToBeChecked.forEach(date => {
                let diff = moment(date).diff(moment(aWeekAgo), 'days');
                if (diff > 0) {
                    if (nearestDateWeek) {
                        if (moment(date).diff(moment(nearestDateWeek), 'days') < 0) {
                            nearestDateWeek = date;
                        }
                    } else {
                        nearestDateWeek = date;
                    }
                }
            });

            let nearestDateMonth;

            datesToBeChecked.forEach(date => {
                let diff = moment(date).diff(moment(aMonthAgo), 'days');
                if (diff > 0) {
                    if (nearestDateMonth) {
                        if (moment(date).diff(moment(nearestDateMonth), 'days') < 0) {
                            nearestDateMonth = date;
                        }
                    } else {
                        nearestDateMonth = date;
                    }
                }
            });


            ////////////////////////////////////////

            const lastWeek = facilities.filter(function (d) { return d.date == nearestDateWeek })
            const lastMonth = facilities.filter(function (d) { return d.date == nearestDateMonth })
            const lastYear = facilities.filter(function (d) { return d.date == nearestDate })

            let appointeddiv, title, setBarWidth, barColor, vertAxis, bottommargin

            const genderdata = d3.nest()
                .key(d => d.sex)
                .rollup(v => d3.sum(v, d => d.value))
                .entries(allCurrentDate);

            const changeLastWeek = d3.nest()
                .key(d => d.sex)
                .rollup(v => d3.sum(v, d => d.value))
                .entries(lastWeek);

            const changeLastMonth = d3.nest()
                .key(d => d.sex)
                .rollup(v => d3.sum(v, d => d.value))
                .entries(lastMonth);

            const changeLastYear = d3.nest()
                .key(d => d.sex)
                .rollup(v => d3.sum(v, d => d.value))
                .entries(lastYear);

            const totalPopNumMale = addCommas(genderdata[0].value)
            d3.selectAll(".pop-num-male").append('text').text(totalPopNumMale)

            const totalPopNumFemale = addCommas(genderdata[1].value)
            d3.selectAll(".pop-num-female").append('text').text(totalPopNumFemale)

            const totalPopNum = genderdata[0].value + genderdata[1].value
            d3.selectAll(".total-pop-num").append('text').text(addCommas(totalPopNum))


            // initial - weekly change
            let totalPopNumMaleChange = addPlus(addCommas(genderdata[0].value - changeLastWeek[0].value)),
                totalPopNumFemaleChange = addPlus(addCommas(genderdata[1].value - changeLastWeek[1].value)),
                totalPopNumChange = addPlus(addCommas((genderdata[0].value + genderdata[1].value) - (changeLastWeek[0].value + changeLastWeek[1].value)))
            $(".total-pop-num-male-change").text(totalPopNumMaleChange)
            $(".total-pop-num-female-change").text(totalPopNumFemaleChange)
            $(".total-pop-num-change").text(totalPopNumChange)
            let totalPopNumMaleChangePerc, totalPopNumFemaleChangePerc, totalPopNumChangePerc
            if (totalPopNumMaleChange > 0) {
                totalPopNumMaleChangePerc = '+' + (genderdata[0].value / changeLastWeek[0].value).toFixed(1) + '%'
            } else {
                totalPopNumMaleChangePerc = '-' + (1 - genderdata[0].value / changeLastWeek[0].value).toFixed(1) + '%'
            }
            if (totalPopNumFemaleChange > 0) {
                totalPopNumFemaleChangePerc = '+' + (genderdata[1].value / changeLastWeek[1].value).toFixed(1) + '%'
            } else {
                totalPopNumFemaleChangePerc = '-' + (1 - genderdata[1].value / changeLastWeek[1].value).toFixed(1) + '%'
            }
            if (totalPopNumChange > 0) {
                totalPopNumChangePerc = '+' + ((genderdata[0].value + genderdata[1].value) / (changeLastWeek[0].value + changeLastWeek[1].value)).toFixed(1) + '%'
            } else if (totalPopNumChange < 0 || totalPopNumChange > -.1) {
                totalPopNumChangePerc = '' + (1 - (genderdata[0].value + genderdata[1].value) / (changeLastWeek[0].value + changeLastWeek[1].value)).toFixed(1) + '%'
            } else {
                totalPopNumChangePerc = '-' + (1 - (genderdata[0].value + genderdata[1].value) / (changeLastWeek[0].value + changeLastWeek[1].value)).toFixed(1) + '%'
            }
            // $(".total-pop-num-male-change-perc").text(totalPopNumMaleChangePerc)
            // $(".total-pop-num-female-change-perc").text(totalPopNumFemaleChangePerc)
            // $(".total-pop-num-change-perc").text(totalPopNumChangePerc)

            const changeSelect = d3.select("#changedate")
                .on("change", function () {
                    let changeDate = this.value
                    updateChange(changeDate)
                })
            function updateChange(changeDate) {
                let changeData
                if (changeDate == 'Week') { changeData = changeLastWeek }
                else if (changeDate == 'Month') { changeData = changeLastMonth }
                else if (changeDate == 'Year') { changeData = changeLastYear }
                else if (changeDate == 'otherdate') {
                    //changeData = genderdata
                    $('#selectotherdate').removeClass('hidden')
                }
                let totalPopNumMaleChange = addCommas(addPlus(genderdata[0].value - changeData[0].value)),
                    totalPopNumFemaleChange = addCommas(addPlus(genderdata[1].value - changeData[1].value)),
                    totalPopNumChange = addCommas(addPlus((genderdata[0].value + genderdata[1].value) - (changeData[0].value + changeData[1].value)))
                $(".total-pop-num-male-change").text(totalPopNumMaleChange)
                $(".total-pop-num-female-change").text(totalPopNumFemaleChange)
                $(".total-pop-num-change").text(totalPopNumChange)
                let totalPopNumMaleChangePerc, totalPopNumFemaleChangePerc, totalPopNumChangePerc
                if (totalPopNumMaleChange > 0) {
                    totalPopNumMaleChangePerc = '+' + ((changeData[0].value / genderdata[0].value) * 100).toFixed(1) + '%'
                } else {
                    totalPopNumMaleChangePerc = ((1 - (genderdata[0].value / changeData[0].value)) * 100).toFixed(1) + '%'
                }
                if (totalPopNumFemaleChange > 0) {
                    totalPopNumFemaleChangePerc = '+' + ((changeData[1].value / genderdata[1].value) * 100).toFixed(1) + '%'
                } else {
                    totalPopNumFemaleChangePerc = ((1 - (genderdata[1].value / changeData[1].value)) * 100).toFixed(1) + '%'
                }
                if (totalPopNumChange > 0) {
                    totalPopNumChangePerc = '+' + (((changeData[0].value + changeData[1].value) / (genderdata[0].value + genderdata[1].value)) * 100).toFixed(1) + '%'
                } else {
                    totalPopNumChangePerc = ((1 - ((genderdata[0].value + genderdata[1].value) / (changeData[0].value + changeData[1].value))) * 100).toFixed(1) + '%'
                }

                // FIX PERCENTAGES
                // $(".total-pop-num-male-change-perc").text(totalPopNumMaleChangePerc)
                // $(".total-pop-num-female-change-perc").text(totalPopNumFemaleChangePerc)
                // $(".total-pop-num-change-perc").text(totalPopNumChangePerc)

            }

            //case data changes over previous month
            const caseData = d3.nest()
                .key(d => d.group)
                .rollup(v => d3.sum(v, d => d.value))
                .object(allCurrentDate);

            const caseChangeLastMonth = d3.nest()
                .key(d => d.group)
                .rollup(v => d3.sum(v, d => d.value))
                .object(lastMonth);

            const totalLastMonth = changeLastMonth[0].value + changeLastMonth[1].value
            const totalChange = totalPopNum - totalLastMonth
            const pretrialMonthChange = caseData.Pretrial - caseChangeLastMonth.Pretrial
            const sentencedMonthChange = caseData["Fully Sentenced"] - caseChangeLastMonth["Fully Sentenced"]
            const awaitingStatePrisonMonthChange = caseData["Awaiting State Prison"] - caseChangeLastMonth["Awaiting State Prison"]

            d3.selectAll('.total-change').append('text').text(function (d) {
                if (totalChange > 1) {
                    return '+' + totalChange
                } else {
                    return totalChange
                }
            })
            d3.selectAll('.pop-num-pretrial-perc').append('text').text(function (d) {
                if (pretrialMonthChange > 1) {
                    return '+' + pretrialMonthChange
                } else {
                    return pretrialMonthChange
                }
            })
            d3.selectAll('.pop-num-sentenced-perc').append('text').text(function (d) {
                if (sentencedMonthChange > 1) {
                    return '+' + sentencedMonthChange
                } else {
                    return sentencedMonthChange
                }
            })
            d3.selectAll('.pop-num-transfer-perc').append('text').text(function (d) {
                if (awaitingStatePrisonMonthChange > 1) {
                    return '+' + awaitingStatePrisonMonthChange
                } else {
                    return awaitingStatePrisonMonthChange
                }
            })

            //AB-109 data changes over previous month
            const subCaseData = d3.nest()
                .key(d => d.subgroup)
                .rollup(v => d3.sum(v, d => d.value))
                .object(allCurrentDate);

            const subCaseDataLastMonth = d3.nest()
                .key(d => d.subgroup)
                .rollup(v => d3.sum(v, d => d.value))
                .object(lastMonth);

            const ab109pop = subCaseData["N3 Partially Sentenced"] + subCaseData["Parole Revocation 3000.08 FPC"] + subCaseData["PRCS Revocation 3455"] + subCaseData["Flash Incarceration 3454"] + subCaseData["County Sentenced N3"]
            const ab109popLastMonth = subCaseDataLastMonth["N3 Partially Sentenced"] + subCaseDataLastMonth["Parole Revocation 3000.08 FPC"] + subCaseDataLastMonth["PRCS Revocation 3455"] + subCaseDataLastMonth["Flash Incarceration 3454"] + subCaseData["County Sentenced N3"]
            const ab109change = ab109pop - ab109popLastMonth

            d3.selectAll('.ab109-pop').append('text').text(addCommas(ab109pop))
            d3.selectAll('.ab109-change').append('text').text(function (d) {
                if (ab109change > 1) {
                    return '+' + ab109change
                } else {
                    return ab109change
                }
            })


        })//csv

}

updateCharts()


